import { IResaleItem } from './filter-by-cd.types'
import { apiAdmin } from '../../../../shared/services/axiosInstace'

export async function fetchCompanies(): Promise<IResaleItem[]> {
	const response = await apiAdmin.get(`/companies`)
	return response.data
}
